// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1241":"1e69e967","1345":"dbae4d70"}[chunkId] + ".chunk.css";
};